import i18n from "i18n";
import CarsReport from "components/ControlCenterReports/CarsReport/CarsReport";
import ControllersReport from "components/ControlCenterReports/ControllersReport/ControllersReport";
import ProductsReport from "components/ControlCenterReports/ProductsReport/ProductsReport";
import VolunteerReport from "components/ControlCenterReports/VolunteerReport/VolunteerReport";

export const REPORTS_TABS: { tabTitle: string; tabComponent: React.FC }[] = [
  {
    tabTitle: i18n.t("volunteersReport"),
    tabComponent: VolunteerReport,
  },
  {
    tabTitle: i18n.t("productsReport"),
    tabComponent: ProductsReport,
  },
  {
    tabTitle: i18n.t("controllersReport"),
    tabComponent: ControllersReport,
  },
  {
    tabTitle: i18n.t("carsReport"),
    tabComponent: CarsReport,
  },
];
